import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'country'
})
export class CountryPipe implements PipeTransform {

  transform(countryAbbr: 'us' | 'ca'): string {
    switch (countryAbbr) {
      case 'us':
        return 'United States of America';
      case 'ca':
        return 'Canada';
      default:
        return 'N/A';
    }
  }

}
